import { queryOptions } from '@tanstack/react-query';
import { ApiError } from '~/components/Providers/APIClient';
import { PaginatedResponse } from '~/util/types/api';
import { RecurringShift, Shift } from '~/util/types/shifts';
import { apiQueryFn } from '../utils';
import { shiftsFiltersType } from '~/routes/_authenticated/staff/shifts/-SearchParams';

export const shiftsQuery = (filters: shiftsFiltersType) =>
    queryOptions<PaginatedResponse<Shift>, ApiError>({
        queryKey: [
            'shifts',
            filters?.status,
            filters?.user?.id,
            filters?.page,
            filters?.per_page,
        ],
        queryFn: apiQueryFn<PaginatedResponse<Shift>>({
            path: `/shifts`,
            method: 'GET',
            query: {
                status: filters?.status,
                user_id: filters?.user?.id,
                page: filters?.page,
                per_page: filters?.per_page,
            },
            attachAuth: true,
        }),
    });

export const myShiftsQuery = ({ page, per_page }: shiftsFiltersType = {}) =>
    queryOptions<PaginatedResponse<Shift>, ApiError>({
        queryKey: ['shifts', 'me', page, per_page],
        queryFn: apiQueryFn<PaginatedResponse<Shift>>({
            path: `/shifts/@me`,
            method: 'GET',
            query: {
                page: page,
                per_page: per_page,
            },
            attachAuth: true,
        }),
    });

export const myActiveShiftsQuery = () =>
    queryOptions<Shift[], ApiError>({
        queryKey: ['shifts', 'me_active'],
        queryFn: async () => {
            const data = await apiQueryFn<PaginatedResponse<Shift>>({
                path: `/shifts/@me`,
                method: 'GET',
                query: {
                    page: 1,
                    per_page: 20,
                },
                attachAuth: true,
            })();

            return data.data.filter(
                (shift) =>
                    shift.status === 'Running' &&
                    Date.now() >= Date.parse(shift.start_at),
            );
        },
    });

export const recurringShiftsQuery = () =>
    queryOptions<RecurringShift[], ApiError>({
        queryKey: ['recurring_shifts'],
        queryFn: apiQueryFn<RecurringShift[]>({
            path: `/shifts/recurring`,
            attachAuth: true,
        }),
    });
